module.exports = __webpack_public_path__ + "img/checkbox_cancel.b4a0311f.svg";